<template lang="pug">
	.sizes-edit(v-if="showed")
		.card
			.card-header
				span Edit {{ getType() }} sizes
			.card-body.collapse.show
				.form-line.separator
					.exist-sizes
						.control-button(v-for="size in sizes" @click="remove(size)" v-b-tooltip.hover="{delay: { show: 0, hide: 100 }, html: true, customClass: 'high-z-index'}" :title="(size.title ? (size.title + '<br>') : '') + size.width + ' x ' + size.height")
							.size-icon(:class="{selected: Layout.getPreviewSizeKey() === `${size.width}x${size.height}`}" :style="getSizeStyle(size)")
								span.fa.fa-remove
				.templates(:span="8")
					.template-container(v-for="size in templateSizes" :class="{selected: sizesKeys[size.width + ':' + size.height]}" @click="sizesKeys[size.width + ':' + size.height] ? remove(size) : add(size)" :style="getSizeStyle(size, 200)")
						span.title(v-if="size.width > size.height") {{size.width}} x {{size.height}}
						span.title(v-if="size.width <= size.height" v-html="size.width + '<br>x<br>' + size.height")
				.form-line.separator
				.form-actions
					button.btn.btn-primary.create(type="submit" :class="{disabled: width < 1 || height < 1}" v-on:click="create()")
						i.fa.fa-plus
						| &nbsp;&nbsp;Add custom size
					input.form-control.title(size="16" type="text" v-model="title" placeholder="Size title")
					input.form-control.width(size="16" type="text" v-model="width" placeholder="width")
					span.x
					input.form-control.height(size="16" type="text" v-model="height" placeholder="height")

					button.btn.btn-dark.hide(type="button" v-on:click="close()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Creative }			from '../../services/Creative'
	import { Version }			from '../../services/Version'
	import { Layout }			from '../../services/Layout'

	export default {
		name: "SizesEdit",
		mixins: [Screen],
		props: ['type'],
		screen: {
			updateOn: ["Selected Version Changed: [options.sizes]"],
			events: {
				"Show SizesEdit": function(type) {

					if (type) this.currentType = type;
					this.show();

				}
			}
		},
		data() {

			this.sizes = [];
			this.sizesKeys = {};
			this.templateSizes = [];
			this.currentType = null;
			this.Layout = Layout;

			return {
				showed: false,
				title: '',
				width: '',
				height: ''
			};

		},
		methods: {
			getType() {

				return this.currentType || this.type || Creative.SelectedCreative?.type || 'banner';

			},
			collectData() {

				let type = this.getType();

				this.sizes = Version.SelectedVersion?.options?.sizes || [];
				this.sizesKeys = _.fromPairs(_.map(this.sizes, size => [size.width + ':' + size.height, true]));
				this.templateSizes = _.orderBy(_.filter(_.values(Metadata.Sizes), o => o.type === type), o => o.width/o.height);

			},
			getSizeStyle(size, width = 50) {

				let maxDimension = Math.max(size.width, size.height),
					scale = width / maxDimension;

				return {
					width: `${size.width * scale}px`,
					height: `${size.height * scale}px`,
				}

			},
			add(size) {

				Server.sendToSocket({
					AddSize: {
						versionId: Version.SelectedVersion.id,
						size: _.pick(size, ['title', 'width', 'height'])
					}
				});

			},
			remove(size) {

				Server.sendToSocket({
					RemoveSize: {
						versionId: Version.SelectedVersion.id,
						sizePosition: this.sizes.findIndex(s => s.title === size.title && s.width === size.width && s.height === size.height)
					}
				});

			},
			create() {

				Server.sendToSocket({
					AddSize: {
						versionId: Version.SelectedVersion.id,
						size: {
							title: this.title,
							width: parseInt(this.width),
							height: parseInt(this.height)
						}
					}
				});

				this.title = '';
				this.width = 0;
				this.height = 0;

			},
			close() {

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.sizes-edit
		display: flex
		position: absolute
		z-index: 1200
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 750px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.exist-sizes
				display: flex
				flex-direction: row
				width: 100%
				justify-content: center
				align-items: center

				.control-button
					display: flex
					align-items: center
					justify-content: center
					cursor: pointer
					margin: 0 5px 0 5px
					width: 50px
					height: 50px
					color: #000
					text-align: center
					font-size: 12px
					line-height: 20px

					.size-icon
						display: flex
						align-items: center
						justify-content: center
						height: 30px
						width: 30px
						border: 1px solid rgba(0,0,0,0.3)
						border-radius: 5px
						background: rgba(255,255,255,0.1)

						span
							display: none
							color: rgba(255,0,0,0.5)
							font-size: 15px

					&:hover

						.size-icon
							background: rgba(255,0,0,0.2)

							span
								display: block
			.templates
				display: flex
				flex-wrap: wrap
				justify-content: space-around
				align-items: center
				max-height: 460px
				overflow-y: auto

				.template-container
					display: flex
					flex-direction: column
					align-items: center
					justify-content: center
					width: 200px
					margin: 10px
					cursor: pointer
					text-align: center
					border: 1px solid #4c4f54
					border-radius: 5px
					box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .14), 0 2px 1px -1px rgba(0, 0, 0, .12), 0 1px 3px 0 rgba(0, 0, 0, .20)
					background-color: #343b41
					user-select: none

					&.selected
						border-color: #e1a82d

					.preview
						display: block
						width: 200px
						height: 200px
						margin: 10px
						background-size: contain
						background-repeat: no-repeat
						background-position: center

					.title

		.form-group
			display: flex
			flex-direction: column
			margin-left: 40px

			&:first-child
				margin-left: 0

			&.bottom-align
				align-self: flex-end

		.properties-content
			height: 200px

		.form-line
			display: flex
			flex-direction: row

		.form-actions
			display: flex
			flex-direction: row
			margin-top: 20px
			align-items: center
			justify-content: left

			input
				width: 100px

			input.title
				width: 200px
				margin-right: 20px

			input::placeholder
				color: rgba(255,255,255,0.3)

			span
				margin: 0 10px

			button.create
				margin-right: 20px

			button.hide
				margin-left: auto
				color: #fff

</style>
